// Firebase Auth compares addresses without case, so the apps and the backend do too.
export const isSameEmail = (
  a: string | null | undefined,
  b: string | null | undefined,
): boolean => !!a?.trim() && a.trim().toLowerCase() === b?.trim().toLowerCase();
